import React from 'react'
import StepWizard from 'react-step-wizard'
import styled from 'styled-components'

import { mediaQueries } from '../../styles/variables'

import StepNav from './StepNav'

const Wrapper = styled.div((props) => ({
  display: props.hidden ? 'none' : 'block',
  width: '100%',
  margin: '0 auto',
  clipPath: 'inset(-100vh 0%)',
  ...props.styles,
  [mediaQueries.mobile]: {
    height: '100%',
    overflowY: 'hidden',
    width: '100%',
    padding: '30px 0',
  },
}))

export default ({
  hidden = false,
  activeStep = 1,
  shouldRenderNav,
  children,
  steps,
  onStepChange,
  instance,
  styles,
}) => {
  return (
    <Wrapper
      data-testid="stepper"
      id="add-project-modal-stepper"
      hidden={hidden}
      styles={styles}
    >
      {shouldRenderNav && shouldRenderNav(activeStep) && (
        <StepNav steps={steps} current={activeStep} />
      )}
      <StepWizard
        initialStep={activeStep}
        isLazyMount
        onStepChange={onStepChange}
        instance={instance}
        className="add-project-step-wizard"
      >
        {children}
      </StepWizard>
    </Wrapper>
  )
}
